<template>
  <AGTag class="ag-tag-risco" readonly :class="computedClass" :label="computedLabel" />
</template>

<script>
import AGTag from '@/components/common/AGTag.vue';
import NIVEL_RISCO from '@/constants/ConstantNivelRisco';
import UtilsAnalise from '@/utils/UtilsAnalise';

export default {
  components: {
    AGTag,
  },

  props: {
    nivel: {
      type: String,
      default: null,
      validator: (val) => Object.values(NIVEL_RISCO).includes(val),
    },
  },

  computed: {
    computedLabel() {
      const description = UtilsAnalise.getDescriptionForGrauRisco(this.nivel);
      return description ?? 'Em análise';
    },

    computedClass() {
      const validKeys = Object.values(NIVEL_RISCO);
      const nivelKey = validKeys.includes(this.nivel) ? this.nivel : 'EM_ANALISE';
      return `--nivel-${nivelKey.toLowerCase().replace('_', '-')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin tagTypeStyles($backgroundColor, $textColor, $borderColor) {
  background-color: $backgroundColor !important;
  color: $textColor;
  border-color: $borderColor;
}

.ag-tag-risco {
  border: none;

  &.--nivel-inexpressivo {
    @include tagTypeStyles($neutral-color-low-dark, $neutral-color-high-medium, $neutral-color-high-light);
  }

  &.--nivel-baixo {
    @include tagTypeStyles($feedback-color-success-light, $feedback-color-success-dark, $feedback-color-success-light);
  }

  &.--nivel-moderado {
    @include tagTypeStyles(
      $feedback-color-attention-light,
      $feedback-color-attention-dark,
      $feedback-color-attention-light
    );
  }

  &.--nivel-elevado {
    @include tagTypeStyles(
      $feedback-color-more-attention-light,
      $feedback-color-more-attention-dark,
      $feedback-color-more-attention-light
    );
  }

  &.--nivel-critico {
    @include tagTypeStyles($feedback-color-error-light, $feedback-color-error-medium, $feedback-color-error-light);
  }

  &.--nivel-em-analise {
    @include tagTypeStyles(#8e8e9347, #8e8e93, #8e8e9347);
  }

  &.--nivel-excluida {
    @include tagTypeStyles(#f2e1e2, #962e33, #f2e1e2);
  }

  &.--nivel-inativa {
    @include tagTypeStyles(#ece7f5, 52526b, #ece7f5);
  }

  &.--nivel-nao-utilizada {
    @include tagTypeStyles(#f9efe4, #52526b, #f9efe4);
  }
}
</style>
